import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import AuthCard from '../components/AuthCard';
import TextField from '../components/TextField';
import { Alert, SubmitButton } from '../components/Feedback';
import { candidateApi } from '../services/pspApi';
import { isValidEmail } from '../utils/masks';

const ForgotPassword = () => {
    const { friendly_url } = useParams();
    const navigate = useNavigate();
    const base = `/processos-seletivos/${friendly_url}`;

    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [sent, setSent] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!isValidEmail(email)) {
            setError('Informe um e-mail válido.');
            return;
        }

        setError('');
        setLoading(true);
        await candidateApi.forgotPassword(email, friendly_url);
        setLoading(false);
        setSent(true);
    };

    return (
        <div className="psp-center psp-center--padded">
            <AuthCard
                icon="fa-key"
                title="Recuperar senha"
                subtitle="Informe seu e-mail para receber o link de redefinição de senha."
                onBack={() => navigate(`${base}/login`)}
            >
                {sent ? (
                    <div className="psp-stack">
                        <Alert type="success">
                            Se o e-mail informado estiver cadastrado, você receberá em instantes um link para redefinir a senha.
                        </Alert>
                        <button type="button" className="psp-btn psp-btn--outline" onClick={() => navigate(`${base}/login`)}>
                            Voltar para o login
                        </button>
                    </div>
                ) : (
                    <form className="psp-stack" onSubmit={handleSubmit} noValidate>
                        <Alert type="error">{error}</Alert>
                        <TextField name="email" type="email" label="E-mail" value={email} onChange={(_, v) => setEmail(v)} required autoComplete="email" />
                        <SubmitButton loading={loading}>Enviar link</SubmitButton>
                    </form>
                )}
            </AuthCard>
        </div>
    );
};

export default ForgotPassword;
